import _ from 'lodash';


/**
 * 지역정보
 * - 각 지역ID 에 대한 지역명 및 국기아이콘등 정보제공
 * - 실제 php단에 정의된 내용과 상관없이 하드코딩 선언되어있음.
 * - php에서 해당 지역에 대한 변동이 있으면 이 파일도 같이 수정해줘야함.
 */
class Region {
    constructor(id, code, name, country) {
        this.id = parseInt(id); // region id
        this.code = parseInt(code); // region code
        this.name = name; // region name
        this.country = country; // region country iso (알파벳 3자리)

        this.currency = this.getCurrency(); // region currency
        this.flag16 = this.getFlag16(); // 16px 국기 url
        this.flag32 = this.getFlag32(); // 32px 국기 url

        this.transport = this.getTransport();
        this.transport_text = this.getTransportText();
        this.transport_icon32 = this.getTransportIcon32(); // 32px 운송방법 아이콘
        this.transport_material_icon = this.getTransportMaterialIcon(); // 운송방법 아이콘

        this.currency_sign = this.getCurrencySign(); // 통화기호

        this.active = this.getActive(); // 현재 센터가 서비스중인지 여부 (true, false)
    }

    /**
     * 서비스여부
     * @returns bool
     */
    getActive() {
        if (this.code === 3
            || this.code === 4
            || this.code === 1
        ){
            return false;
        }

        return true;
    }

    /**
     * 통화
     * @return (string)
     */
    getCurrency() {
        switch (this.country) {
            case 'USA':
                return 'USD';
            case 'KOR':
                return 'KRW';
            case 'GBR':
                return 'GBP';
            case 'DEU':
            case 'FRA':
                return 'EUR';
            case 'JPN':
                return 'JPY';
            case 'CHN':
                return 'CNY';
            case 'AUS':
                return 'AUD';
            case 'CAN':
                return 'CAD';

        }

        return null;
    }

    /**
     * 국기 16px
     * @return (string)
     */
    getFlag16() {
        switch (this.country) {
            case 'USA':
                return '/img/flags/16/u/United States of America.png';
            case 'KOR':
                return '/img/flags/16/s/South Korea.png';
            case 'GBR':
                return '/img/flags/16/u/United Kingdom(Great Britain).png';
            case 'DEU':
                return '/img/flags/16/g/Germany.png';
            case 'JPN':
                return '/img/flags/16/j/Japan.png';
            case 'CHN':
                return '/img/flags/16/c/China.png';
            case 'AUS':
                return '/img/flags/16/a/Australia.png';
            case 'FRA':
                return '/img/flags/16/f/France.png';
            case 'CAN':
                return '/img/flags/16/c/Canada.png';

        }

        return null;
    }

    /**
     * 국기 32px
     * @return (string)
     */
    getFlag32() {
        switch (this.country) {
            case 'USA':
                return '/img/flags/32/u/United States of America (USA).png';
            case 'KOR':
                return '/img/flags/32/s/South Korea.png';
            case 'GBR':
                return '/img/flags/32/u/United Kingdom(Great Britain).png';
            case 'DEU':
                return '/img/flags/32/g/Germany.png';
            case 'JPN':
                return '/img/flags/32/j/Japan.png';
            case 'CHN':
                return '/img/flags/32/c/China.png';
            case 'AUS':
                return '/img/flags/32/a/Australia.png';
            case 'FRA':
                return '/img/flags/32/f/France.png';
            case 'CAN':
                return '/img/flags/32/c/Canada.png';

        }

        return null;
    }

    /**
     * 운송방법
     * @return (string) air: 항공, sea: 해상
     */
    getTransport() {
        if (this.code === 4
            || this.code === 8
            || this.code === 10
        ){
            return 'sea';
        }

        return 'air';
    }

    /**
     * 운송방법 한글
     * @return (string) air: 항공, sea: 해상
     */
    getTransportText() {

        return this.transport === 'air' ? '항공' : '해상';
    }

    /**
     * 운송방법 아이콘 32px
     * @return (string)
     */
    getTransportIcon32() {
        if (this.transport === 'air'){
            return '/img/icons/32/airplane-flight.png';
        } else if (this.transport === 'sea'){
            return '/img/icons/32/sea-ship-with-containers.png';
        }
        return null;
    }

    /**
     * 운송방법 material icon
     * @return (string)
     */
    getTransportMaterialIcon() {
        if (this.transport === 'air'){
            return 'flight_takeoff';
        } else if (this.transport === 'sea'){
            return 'directions_boat';
        }
        return null;
    }

    /**
     * 통화기호
     * @return (string)
     */
    getCurrencySign() {
        switch (this.currency) {
            case 'USD':
                return '$';
            case 'KRW':
                return '₩';
            case 'EUR':
                return '€';
            case 'JPY':
                return '¥';
            case 'CNY':
                return '¥';
            case 'GBP':
                return '£';
            case 'AUD':
                return 'AU$';
            case 'CAD':
                return 'CA$';
            default:
                return this.currency;
        }
    }

    /**
     * 커스텀용 함수
     * 오사카인지 반환
     * @returns {boolean}
     */
    isOsaka() {
        return this.id === 9
            || this.id === 10;
    }

    /**
     * 항공인지 반환
     * @returns {boolean}
     */
    isAir() {
        return this.transport === 'air';
    }

    /**
     * 해상인지 반환
     * @returns {boolean}
     */
    isSea() {
        return this.transport === 'sea';
    }
} // end class RegionInfo

// 지역정보 컬렉션 정의
const REGIONS = [
    new Region(1, 1, '일본-항공1센터', 'JPN'),
    new Region(2, 2, '미국(뉴저지/델라웨어)', 'USA'),
    new Region(3, 3, '중국(위해)항공', 'CHN'),
    new Region(4, 4, '중국(위해)해상', 'CHN'),
    new Region(5, 5, '영국', 'GBR'),
    new Region(6, 6, '독일(프랑크푸르트)', 'DEU'),
    new Region(7, 7, '호주(브리즈번)', 'AUS'),
    new Region(8, 8, '일본-해상(후쿠오카)', 'JPN'),
    new Region(9, 9, '일본-항공(오사카)', 'JPN'),
    new Region(10, 10, '일본-해상(오사카)', 'JPN'),
    new Region(11, 11, '호주(시드니)', 'AUS'),
    new Region(12, 12, '미국(오레곤)', 'USA'),
    new Region(13, 13, '독일(디첸바흐)', 'DEU'),
    new Region(14, 14, '프랑스', 'FRA'),
    new Region(15, 15, '캐나다(1센터)', 'CAN'),
    new Region(16, 16, '캐나다', 'CAN'),
    new Region(17, 17, '독일(켈스터바흐)', 'DEU'),
];

/**
 * 지역ID로 지역객체 생성
 * @param region_id
 * @returns {Region}
 */
export function get_region(region_id) {
    if (! region_id) {
        return null;
    }
    region_id = parseInt(region_id);
    return _.find(REGIONS, {id: region_id});
}

/**
 * 현재 서비스중인 모든 지역반환
 * @returns []
 */
export function get_active_regions() {
    return _.filter(REGIONS, {active: true});
}

/**
 * region_code로 지역객체 생성
 * @param region_code
 * @returns {Region}
 */
export function get_region_by_code(region_code) {
    if (! region_code) {
        return null;
    }
    region_code = parseInt(region_code);
    return _.find(REGIONS, {code: region_code});
}